exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bid-input-wrapper{padding-left:0;padding-right:0;margin-bottom:10px;padding-left:20px;padding-right:20px}.bid-input-wrapper .input-group-addon{color:#232323}.bid-input-wrapper input{width:100px !important}.bid-input-wrapper .input-group{flex-wrap:nowrap}.bid-input-wrapper .bid-input{max-width:300px;margin-left:auto;margin-right:auto}.bid-input-wrapper .bid-input .form-control{height:50px;color:#777 !important}.confirm-button-container{text-align:center}.confirm-button{padding:0 5px 0 5px !important}", ""]);

// exports
